// ============================================================
// 🔐 ROUTE → PERMISSION MAP  (fail-closed)
// ============================================================
// Yahan har route ka required permission code define hai.
// Jo route is map me NAHI hai, wo BLOCK ho jaayega (fail-closed).
// Naya page add karo to yahan uski entry bhi zaroor add karna.
//
// Notes:
//  • ADMIN har cheez bypass karta hai (usePermissions ka isAdmin).
//  • ALWAYS_ALLOWED wale routes har logged-in user ko milte hain.
//  • Value string (ek permission) ya array (koi ek bhi ho to allow) ho sakti hai.
// ============================================================

/** Har authenticated user ke liye khula — inhe kabhi block mat karo. */
export const ALWAYS_ALLOWED = [
  '/dashboard',      // role-based landing page
  '/my-profile',     // apni hi profile
];

/**
 * Route pattern → required permission code(s).
 * `:param` dynamic segment hai, `*` trailing wildcard hai.
 */
export const ROUTE_PERMISSIONS = {
  // ── Dashboard ────────────────────────────────────────────
  '/dashboard/realtime': 'DASHBOARD_VIEW',
  '/dashboard/lead': 'DASHBOARD_VIEW',
  '/dashboard/order': 'DASHBOARD_VIEW',

  // ── Leads ────────────────────────────────────────────────
  '/leads': 'LEAD_VIEW',
  '/whatsapp': 'CHAT_HISTORY_VIEW',

  // ── Orders ───────────────────────────────────────────────
  '/orders': 'ORDERS_VIEW',
  '/orders/add': 'ORDERS_CREATE',
  '/orders/draft': 'ORDERS_VIEW',
  '/orders/reassign': 'ORDER_REASSIGN_VIEW',
  '/orders/amount-decrease/:id': 'ORDERS_VIEW',
  '/orders/:id': 'ORDERS_VIEW',
  '/orders/:id/edit': ['ORDERS_EDIT', 'ORDERS_VIEW'],
  '/order-details/:id': 'ORDERS_VIEW',

  // ── Verify ───────────────────────────────────────────────
  '/verified': 'VERIFIED_VIEW',
  '/verified/orders': 'VERIFIED_VIEW',
  '/verified/pending': 'VERIFIED_VIEW',
  '/verified/order/:id': 'VERIFIED_VIEW',
  '/ManualAssignPanel': 'VERIFIED_ASSIGN',

  // ── Dispatch ─────────────────────────────────────────────
  '/DispatchOrder': 'DISPATCH_VIEW',
  '/DispatchOrderverified': 'DISPATCH_VIEW',
  '/dispatched': 'DISPATCH_VIEW',
  '/dispatch-failed': 'DISPATCH_VIEW',

  // ── Logistics pipeline ───────────────────────────────────
  '/InTransit': 'IN_TRANSIT_VIEW',
  '/OFDOrders': 'OFD_VIEW',
  '/DeliveredOrders': 'DELIVERED_VIEW',
  '/NDROrders': 'NDR_VIEW',
  '/NDRRequest': 'NDR_VIEW',
  '/ndr': 'NDR_VIEW',
  '/ndr/pending': 'NDR_VIEW',
  '/ndr/resolved': 'NDR_VIEW',
  '/RTO': 'RTO_VIEW',
  '/rto': 'RTO_VIEW',

  // ── Analytics / MIS ──────────────────────────────────────
  '/analytics': 'ANALYTICS_VIEW',
  '/analytics/aht-bucket': 'ANALYTICS_VIEW',
  '/mis-reports/business-dashboard': 'MIS_REPORTS_VIEW',
  '/mis-reports/orders-target': 'MIS_REPORTS_VIEW',
  '/mis-reports/revenue-target': 'MIS_REPORTS_VIEW',
  '/mis-reports/conversion-target': 'MIS_REPORTS_VIEW',
  '/target': ['TARGET_VIEW', 'TARGET_ASSIGN'],
  '/agent-targets': ['TARGET_VIEW', 'TARGET_ASSIGN'],

  // ── Attendance ───────────────────────────────────────────
  '/attendance': 'ATTENDANCE_VIEW',

  // ── Employees / Floor ────────────────────────────────────
  '/employees': 'EMPLOYEES_VIEW',
  '/employees/list': 'EMPLOYEES_VIEW',
  '/employees/user-permission': 'EMPLOYEES_VIEW',
  '/employees/createPermission': 'EMPLOYEES_VIEW',
  '/employees/add': 'EMPLOYEES_VIEW',
  '/add/employee': 'EMPLOYEES_VIEW',
  '/employees/edit/:id': 'EMPLOYEES_VIEW',
  '/employees/:id': 'EMPLOYEES_VIEW',
  '/floor': 'EMPLOYEES_VIEW',
  '/floor/add': 'EMPLOYEES_VIEW',

  // ── Vendors / B2B / Centers ──────────────────────────────
  '/b2b-partners': 'B2B_VIEW',
  '/b2b-partners/add': 'B2B_VIEW',
  '/b2b-partners/:id': 'B2B_VIEW',
  '/b2b-partners/:id/edit': 'B2B_VIEW',
  '/b2b-partners/:id/document': 'B2B_VIEW',
  '/b2b-partners/:id/invoice': 'B2B_VIEW',
  '/b2b-partners/:id/action-edit': 'B2B_VIEW',
  '/centers': 'B2B_VIEW',

  // ── Purchase ─────────────────────────────────────────────
  '/purchase': 'B2B_VIEW',
  '/purchase/add': 'B2B_VIEW',
  '/purchase/orders': 'B2B_VIEW',
  '/purchase/orders/create': 'B2B_VIEW',
  '/purchase/orders/:id': 'B2B_VIEW',
  '/purchase/orders/:id/edit': 'B2B_VIEW',
  '/purchase/invoice/:id': 'B2B_VIEW',

  // ── Ledger ───────────────────────────────────────────────
  '/ledger/partners': 'LEDGER_VIEW',
  '/ledger/stock': 'LEDGER_VIEW',

  // ── Billing ──────────────────────────────────────────────
  '/billing': 'BILLING_VIEW',
  '/billing/self-profile': 'BILLING_VIEW',
  '/billing/list': 'BILLING_VIEW',
  '/billing/add-profile': 'BILLING_VIEW',
  '/billing/add-profile/step2': 'BILLING_VIEW',
  '/billing/invoice/:id': 'BILLING_VIEW',

  // ── Products ─────────────────────────────────────────────
  '/products': 'PRODUCTS_VIEW',
  '/products/category': 'PRODUCTS_VIEW',
  '/products/subcategory': 'PRODUCTS_VIEW',
  '/products/list': 'PRODUCTS_VIEW',
  '/products/add': 'PRODUCTS_VIEW',
  '/products/:id': 'PRODUCTS_VIEW',

  // ── Settings — Sidebar me sirf ADMIN ko dikhta hai.
  //    Non-admin ko tabhi milega jab DB me SETTINGS_VIEW assign ho.
  '/settings/lead-api': 'SETTINGS_VIEW',
  '/settings/order-campaign': 'SETTINGS_VIEW',
  '/settings/lead-disposition': 'SETTINGS_VIEW',
  '/settings/courier-api': 'SETTINGS_VIEW',
  '/settings/courier-api/add': 'SETTINGS_VIEW',

  // ── Stock Management — Sidebar me sirf ADMIN ko dikhta hai ──
  '/stock-management/dashboard': 'STOCK_VIEW',
  '/stock-management/stock-in': 'STOCK_VIEW',
  '/stock-management/transfer': 'STOCK_VIEW',
  '/stock-management/returns': 'STOCK_VIEW',
  '/stock-management/ledger': 'STOCK_VIEW',
  '/stock-management/sampling': 'STOCK_VIEW',
};

// ── Pattern matching ───────────────────────────────────────

const normalize = (p) => {
  const trimmed = String(p || '/').split('?')[0].split('#')[0];
  // trailing slash hatao (root ko chhodkar)
  return trimmed.length > 1 ? trimmed.replace(/\/+$/, '') : trimmed;
};

/** `/orders/:id/edit` → /^\/orders\/[^/]+\/edit$/i */
const patternToRegex = (pattern) => {
  const source = pattern
    .split('/')
    .map((seg) => {
      if (seg === '*') return '.*';
      if (seg.startsWith(':')) return '[^/]+';
      return seg.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    })
    .join('/');
  return new RegExp(`^${source}$`, 'i');
};

// Zyada specific pattern pehle match ho — static segments jyada honge to upar.
// (warna `/orders/:id` pehle match hoke `/orders/add` ko kha jaayega)
const COMPILED = Object.keys(ROUTE_PERMISSIONS)
  .map((pattern) => ({
    pattern,
    regex: patternToRegex(pattern),
    required: ROUTE_PERMISSIONS[pattern],
    staticSegments: pattern.split('/').filter((s) => s && !s.startsWith(':') && s !== '*').length,
    depth: pattern.split('/').length,
  }))
  .sort((a, b) =>
    b.staticSegments - a.staticSegments || b.depth - a.depth || b.pattern.length - a.pattern.length
  );

const ALWAYS_ALLOWED_REGEX = ALWAYS_ALLOWED.map(patternToRegex);

/** Route har logged-in user ke liye khula hai? */
export const isAlwaysAllowed = (pathname) => {
  const p = normalize(pathname);
  return ALWAYS_ALLOWED_REGEX.some((r) => r.test(p));
};

/**
 * Is pathname ke liye required permission code(s) do.
 * @returns {string[]|null} codes (koi ek bhi ho to allow), ya null = map me nahi (fail-closed → block)
 */
export const getRequiredPermissions = (pathname) => {
  const p = normalize(pathname);
  const hit = COMPILED.find((entry) => entry.regex.test(p));
  if (!hit) return null;
  return Array.isArray(hit.required) ? hit.required : [hit.required];
};
